import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { Action, WorkerPool } from "types/generated";
import { checkAllowedAction } from "utils/access";

type WorkerPoolCycleActionProps = {
  onAction: () => void;
  workerPool: WorkerPool;
};

const hasBusyWorkersTooltip = (
  <>
    Some workers are currently busy running jobs. Wait for the jobs to finish before proceeding.
    <br />
    <br />
  </>
);

const cycleInfoTooltip = (
  <>
    Cycling worker pool sends a self-destruct signal to all the workers. The process can take up to
    20 seconds to complete.
  </>
);

const WorkerPoolCycleAction = ({ onAction, workerPool }: WorkerPoolCycleActionProps) => {
  const accessResult = checkAllowedAction(workerPool, Action.WorkerPoolCycle);
  const hasBusyWorkers = workerPool.busyWorkers > 0;

  const getTooltip = () => {
    if (!accessResult.result) {
      return accessResult.message;
    }
    if (hasBusyWorkers) {
      return (
        <>
          {hasBusyWorkersTooltip}
          {cycleInfoTooltip}
        </>
      );
    }
    return cycleInfoTooltip;
  };

  const isDisabled = !accessResult.result || hasBusyWorkers;
  const tooltip = getTooltip();

  return (
    <DropdownMenuItem
      tooltip={tooltip}
      isTooltipActive={!!tooltip}
      tooltipWidthMode="maxWidthSm"
      tooltipPlacement="left"
      onAction={onAction}
      isDisabled={isDisabled}
    >
      Cycle
    </DropdownMenuItem>
  );
};

export default WorkerPoolCycleAction;
